import { Component } from "react";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { InfraLayout } from '../InfraLayout';
import { InfraEntities } from "../InfraEntities";
import { InfraRouterProps } from "../InfraRouterProps";

interface AlertViewPageProps extends NSARouterMakerResult, InfraRouterProps { }

export default class AlertViewPage extends Component<AlertViewPageProps>
{
    override render()
    {
        return (
            <InfraLayout
                {...this.props}
                pages={{
                    entity: InfraEntities.alert(this.props),
                    view: {}
                }}
            >
                <></>
            </InfraLayout>
        );
    }
}